<template>
  <tooltip-media v-if="this.params.value" :MediaData="data" :iconSize="12" />
</template>

<script>
import Vue from "vue"

export default Vue.extend({
  components: {
    TooltipMedia: () => import("@/components/Tooltip/TooltipMedia"),
  },
  name: "IndexMediaImage",
  computed: {
    data() {
      return {
        type: "video",
        url: this.params.value,
      }
    },
  },
})
</script>

<style lang="scss" scoped />
